import { toNumber } from './IncomeReportComponents'

export function csvEscape(value) {
  const text = value === null || value === undefined ? '' : String(value)
  if (/[;"\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`
  return text
}

export function formatCsvNumber(value, { empty = '', fractionDigits = 2, showZero = true } = {}) {
  const n = toNumber(value, null)
  if (n === null) return empty
  if (n === 0 && !showZero) return empty
  return new Intl.NumberFormat('ru-RU', {
    useGrouping: false,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n)
}

export function formatCsvMoney(value, options = {}) {
  return formatCsvNumber(value, { fractionDigits: 2, ...options })
}

export function formatCsvPercent(value, { fraction = false, empty = '', showZero = false } = {}) {
  const n = toNumber(value, null)
  if (n === null) return empty
  const normalized = fraction ? n * 100 : n
  if (normalized === 0 && !showZero) return empty
  const rounded = Math.round((normalized + 1e-12) * 100) / 100
  return `${formatCsvNumber(rounded, {
    empty,
    fractionDigits: 2,
    showZero,
  })}%`
}

export function buildCsvContent(rows) {
  return `\ufeff${rows.map((line) => line.map(csvEscape).join(';')).join('\n')}`
}
